import PropTypes from 'prop-types';
import { Link } from 'components/UI/Link/Link';
import { ReactComponent as CalendarIcon } from 'assets/icons/svgs/icon-calendar.svg';
import { PopularSearches } from 'components/UI/PopularSearches/PopularSearches';

import './EventFinderFooter.scss';

export const EventFinderFooter = (props) => {
  const { popularSearches } = props;
  return (
    <>
      <div
        className="col-sm-12 col-md-6 col-md-offset-1 col-lg-offset-2"
        data-testid="event-finder-footer"
      >
        <PopularSearches popularSearches={popularSearches} />
      </div>
      <div
        className="event-finder__calendar-link col-sm-12 col-md-4 col-lg-2"
        data-testid="event-calendar-link"
      >
        <Link href="/whats-on/event-calendar" startIcon={<CalendarIcon />}>
          Event calendar
        </Link>
      </div>
    </>
  );
};

EventFinderFooter.propTypes = {
  popularSearches: PropTypes.array.isRequired,
};
